/** ---------------电子面单相关链接-------------------------- */

/** 小红书申请电子面单教程链接 */
export const XiaoHongShuApplyEwaybillUrl = "https://qw15p3s8hv.feishu.cn/wiki/TFlNwgTRTiJ3hYk9yGDcttGGnRc";

/** 新小红书申请电子面单教程链接 */
export const NextXiaoHongShuApplyEwaybillUrl = "https://qw15p3s8hv.feishu.cn/wiki/QkJ2w9c5OiUnUIk3La1cv4tBnzg";

/** 微信小店申请电子面单教程链接 */
export const ChannelShopApplyEwaybillUrl =
    "https://qw15p3s8hv.feishu.cn/wiki/U3FWwVmsHiL1pIkylH2ceZVnnVh#SSLidHCXZoHbIsxmK0Ec8wE3nYd";

/** 开通微信小店供货商电子面单教程 */
export const openChannelShopDropshipEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/DY0lwDsSfi8quKkCCnmcAjvanOe";
/** 开通微信小店供货商电子面单链接 */
export const openChannelShopDropshipEwaybillUrl = "https://store.weixin.qq.com/supplier";
/** 授权微信小店供货商电子面单教程 */
export const authorizeChannelShopDropshipEwaybillTutorial =
    "https://qw15p3s8hv.feishu.cn/wiki/wikcniQaWt7LIJqZkuEnMDBTe0c";

/** 开通抖店电子面单教程 */
export const openJinritemaiEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnFYGHvTwDNTSGgVuUeX4LBf";
/** 开通抖店电子面单链接 */
export const openJinritemaiEwaybillUrl =
    "https://fxg.jinritemai.com/ffa/logistics-project/eBill/landing?btm_ppre=a0.b0.c0.d0&btm_pre=a2427.b76571.c902327.d871297&btm_show_id=9b7e5c08-4d8c-4d57-9cbd-423fd6381a09";
/** 开通抖店站外电子面单教程 */
export const openJinritemaiAuthEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnPWnZkRdquGgsXEAYhr0rHg";
/** 开通抖店电子面单链接 */
export const openJinritemaiAuthEwaybillUrl = "https://ebill.douyinec.com/";
/** 授权抖店电子面单教程 */
export const authorizeJinritemaiEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnAcgClSfsTsSXO9WqU9uULZ";
/** 授权抖店站外电子面单教程 */
export const authorizeJinritemaiAuthEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnKQWvtSHXg1ykn7IZRIjY1d";

/** 开通拼多多电子面单教程 */
export const openPddEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcncnyiNrrlQjAfCUWvqMl7nf";
/** 开通拼多多电子面单链接 */
export const openPddEwaybillUrl = "https://mms.pinduoduo.com/logistics/home?msfrom=mms_sidenav";
/** 开通拼多多站外电子面单教程 */
export const openPddAuthEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnRuJpkg6BglGIPHyVxCD6Ag";
/** 开通拼多多站外电子面单链接 */
export const openPddAuthEwaybillUrl = "https://wb.pinduoduo.com/";
/** 授权拼多多电子面单教程 */
export const authorizePddEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnPofym4oeJ0A9FHYF5Y9b2U";
/** 授权拼多多站外电子面单教程 */
export const authorizePddAuthEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnG4Lyk0jM8kxaP2TeGV9p9b";

/** 开通快手电子面单教程 */
export const openKwaiEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnE9yzP5xqiNNe6garhRMHqc";
/** 开通快手电子面单链接 */
export const openKwaiEwaybillUrl = "https://s.kwaixiaodian.com/zone/supply/dadan/electronic-sheet";
/** 开通快手站外电子面单教程 */
export const openKwaiAuthEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnqlMLpycxa6XSZFNKNXu4kh";
/** 开通快手站外电子面单链接 */
export const openKwaiAuthEwaybillUrl = "https://dadan.kwaixiaodian.com/zone/supply/express/electronic-sheet/open";
/** 授权快手电子面单教程 */
export const authorizeKwaiEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnB4uu6TuaqtKVTaGsOFNTef";
/** 授权快手站外电子面单教程 */
export const authorizeKwaiAuthEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnB4uu6TuaqtKVTaGsOFNTef";

/** 开通淘宝电子面单教程 */
export const openTbEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnUDV792esJkxyUxkZdhcbtf";
/** 开通淘宝电子面单链接 */
export const openTbEwaybillUrl = "https://waybill.wuliu.taobao.com/myServiceProviders.htm";
/** 授权淘宝电子面单教程 */
export const authorizeTbEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnKsjk9MzzBxXZbbxDG5GCth";

/** 开通京东电子面单教程 */
export const openJdEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnOK8DG5iKas3leOHvo5z8Mb";
/** 开通京东电子面单链接 */
export const openJdEwaybillUrl = "https://shop.jd.com/jdm/trade/deliveries/electronicWaybill?type=1";
/** 授权京东电子面单教程 */
export const authorizeJdEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcn2NqAYiXqAGC084vuZHqm4H";

/** 开通小红书电子面单教程 */
export const openXhsEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/TFlNwgTRTiJ3hYk9yGDcttGGnRc";
/** 开通小红书电子面单链接 */
export const openXhsEwaybillUrl = "https://ark.xiaohongshu.com/app-order/waybill";
/** 开通小红书站外电子面单教程 */
export const openXhsAuthEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/KhOkwywY1iMUQFkqByGc2VsTnQf";
/** 开通小红书站外电子面单链接 */
export const openXhsAuthEwaybillUrl = "https://ebill.xiaohongshu.com/";
/** 授权小红书电子面单教程 */
export const authorizeXhsEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/Zm77wyRP1iHHJBkuxTcc3fesnQf";
/** 授权小红书站外电子面单教程 */
export const authorizeXhsAuthEwaybillTutorial = "https://qw15p3s8hv.feishu.cn/wiki/CCfYwid7RiWkTGkPS7ycq4urney";

/** ----------------------------------------------------- */

/** 如何关联其他非拼多多店铺教程 */
export const AddShopTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnpCbNEZRYj1BKJY23aJ7TQf";
/** 如何关联其他拼多多店铺 */
export const AddPddShopTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcnsXWQC7zN5FXj3538k8aejg";

export const AddWaybillTemplateTutorial = "https://qw15p3s8hv.feishu.cn/wiki/wikcniDSCEGrY8joTtyeZKTadGh";

/** 阿里巴巴后台密文面单开通链接 */
export const AlibabaEwaybillUrl =
    "https://work.1688.com/home/page/index.htm?spm=a2638g.u_220d5.framenav.du_e7398.65641768sDKPhP&_path_=sellerPro/2017sellerbase_fenxiao/dqdddgj";

/** 承诺日达教程 */
export const AppointmentArrivalUrl = "https://qw15p3s8hv.feishu.cn/wiki/N2pzwVnmDiEDGvk4gFbc03UynWc?from=from_copylink";
